import StripePaymentMethodList from './StripeList';

export default (editor, opts = {}) => {
  const dc = editor.DomComponents;
  const { labels, types } = opts;
  StripePaymentMethodList(dc, labels.stripeList, types.stripeList, opts);
};
